<div class="loading-screen" *ngIf="loading">
  <mat-spinner [diameter]="32"></mat-spinner>
</div>
